// @ts-nocheck
import React from 'react';
import { smallScaleMechanizationToolApi } from '../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default props => <AutocompleteSelect placeholder="Выберите средство малой механизации" fetch={smallScaleMechanizationToolApi.fetch} fetchSingle={smallScaleMechanizationToolApi.get} notFoundText="Средства малой механизации не найдены" renderOption={(smallScaleMechanizatio, Option) => <Option value={smallScaleMechanizatio.id} key={smallScaleMechanizatio.id}>
        {smallScaleMechanizatio.name}
      </Option>} {...props} />;
